import React, { useState, useRef } from "react";
import "./Card.css";

const Card = ({ number, symbol, label, icon }) => {
  const [displayNumber, setDisplayNumber] = useState(number);
  const intervalRef = useRef(null);

  const hasNumber = number !== undefined;

  const handleMouseEnter = () => {
    if (!hasNumber) return;

    let count = 0;
    const target = parseInt(number, 10);

    intervalRef.current = setInterval(() => {
      count += Math.ceil(target / 20);
      if (count >= target) {
        count = target;
        clearInterval(intervalRef.current);
      }
      setDisplayNumber(count.toString().padStart(number.length, "0"));
    }, 40); // slightly slower
  };

  const handleMouseLeave = () => {
    if (!hasNumber) return;
    clearInterval(intervalRef.current);
    setDisplayNumber(number);
  };

  return (
    <div
      className="card"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* ICON MODE */}
      {icon && (
        <img src={icon} alt={label} className="card-icon" />
      )}

      {/* NUMBER MODE */}
      {hasNumber && (
        <div className="card-value">
          <span className="value-number">{displayNumber}</span>
          <span className="value-symbol">{symbol}</span>
        </div>
      )}

      <span className="card-label">{label}</span>
    </div>
  );
};

export default Card;
